<div class="page-msg-container" [ngStyle]="styles">
    <div class="msg-wrapper">
        <div class="msg-inner">
            <ng-content></ng-content>
        </div>
    </div>
</div>
